import { addRange, max } from "../linqSimulation";

export function normalizeTable(node, rowIndex, columnIndex) {
    let body = node?.table?.body;
    let widths = node?.table?.widths;    

    if (!body) {
        if (node.nodeName == 'IMG') {       
            if (node.image && node.image.indexOf('file:///') >= 0) {
                node.nodeName = 'SPAN';
                node.text = '';
                node.image = '';
                node.style = '';
            }
        }

        normalizeStack(node, rowIndex, columnIndex);
        return;
    }

    if (Array.isArray(body) && body.length == 0) {
        node.nodeName = 'SPAN';
        node.text = '';
        node.image = '';
        node.style = '';
        node.table = undefined;
        return;
    }
    
    body = Array.isArray(body) ? body : [body];
    widths = widths ? (Array.isArray(widths) ? widths : [widths]) : null; 

    for (let i = 0; i < body.length; i++) {
        const item = body[i];
        if (widths != null) {
            const width = widths[i];
            normalizeTableBody(item, width, rowIndex, columnIndex);
        } else
            normalizeTableBody(item, null, rowIndex, columnIndex);
    }

    // const tr = node?.table?.body[0];
    // node.table.body = [[tr[0]]];

    if (rowIndex != null) {
        const slice = [];
        for (let i = rowIndex[0]; i <= rowIndex[1]; i++)
            slice.push(node.table.body[i]);
        node.table.body = slice;
    }

    normalizeTableBody(node?.table?.body, node?.table?.widths, rowIndex);
}

export function normalizeStack(node, rowIndex, columnIndex) {
    const stack = node.stack;

    if (!stack || !stack.length)
        return;

    for (let i = 0; i < stack.length; i++) {
        const node = stack[i];
        normalizeTable(stack[i], rowIndex, columnIndex);
    }
}

function normalizeTableBody(body, widths, rowIndex, columnIndex) {
    const maxRowLength = max(body, _ => _.length);

    for (let i = 0; i < body.length; i++) {
        const row = body[i];

        if (row.length < maxRowLength) {
            while (row.length < maxRowLength) {
                row.push({ text: "" });
            }
        }

        if (rowIndex != null && row?.rowSpan != null) {
            row.rowSpan = null;
        }

        if (columnIndex != null && row?.colSpan != null) {
            row.colSpan = null;
        }
           
        if (row.stack) {
            normalizeStack(row, rowIndex, columnIndex);
        }
    }

    if (columnIndex != null) {
        const slice = [];
        for (let i = columnIndex[0]; i <= columnIndex[1]; i++)
            slice.push(body[i]);
        body.length = 0;
        addRange(body, slice);
    }

    if (widths?.length < maxRowLength) {
        while (widths.length < maxRowLength) {
            widths.push({ width: "auto" });
        }
    } 
}